import { selectShouldStudyProgrammeAlertBeShown } from '@components/leerplan/alert/StudyProgrammesAlertSelectors';
import {
  selectCurriculumGrade,
  selectSelectedStudyPrograms,
} from '@store/curriculum/curriculumSelectors';
import { setFilter } from '@store/distribute/distributeState';
import { getStudyProgrammeTypeNameForGrade } from '@utils/curriculumHelper';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsDistributionMode } from '@store/distribute/distributeSelectors';
import { useNavigate } from 'react-router-dom';

const StudyProgrammesAlert = ({ stateParams, distributeSelectionModalRef }) => {
  const dispatch = useDispatch();
  const grade = useSelector(selectCurriculumGrade);
  const gradeName = getStudyProgrammeTypeNameForGrade(grade);
  const isDistributionMode = useSelector(selectIsDistributionMode);
  const shouldStudyProgrammeAlertBeShown = useSelector(selectShouldStudyProgrammeAlertBeShown);
  const studyProgrammeHrefs = useSelector(selectSelectedStudyPrograms);

  const navigate = useNavigate();

  const openDistributeModal = () => {
    const modalRef = distributeSelectionModalRef.current;
    modalRef?.open({
      onConfirm: (selectedPrograms) => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        if (selectedPrograms.length === 0) {
          navigate('/home/leerplan');
        } else {
          params.set('studid', selectedPrograms.join(','));
          navigate(`${url.pathname}?${params.toString()}`);
        }
      },
      onClose: () => {
        if (isDistributionMode && studyProgrammeHrefs.length === 0) {
          navigate('/home/leerplan');
        }
      },
    });
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: <it works>
  useEffect(() => {
    const modalRef = distributeSelectionModalRef.current;
    if (isDistributionMode && !stateParams.studids?.length) {
      openDistributeModal();
    }
    return () => {
      modalRef?.close();
      dispatch(setFilter({ property: 'text', value: '' }));
    };
  }, []);

  return (
    <>
      {shouldStudyProgrammeAlertBeShown && studyProgrammeHrefs.length > 0 && (
        <div className="studyProgrammes">
          ! Je maakt momenteel keuzes voor {studyProgrammeHrefs.length} {gradeName}{' '}
          <a className="link" onClick={openDistributeModal}>
            wijzigen
          </a>
        </div>
      )}
    </>
  );
};

export default StudyProgrammesAlert;
